import { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import colors, { colorWithOpacity } from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import spacing from '../../../helpers/spacing';
import Button, { GenericButtonProps } from '../../Button';
import { InnerStyle } from '../../Button/styles';
import { styledButton } from '../styles';

export type PageNumberProps = {
  shownOnMobile?: boolean;
} & PropsWithChildren<GenericButtonProps>;

const disabledPageButton = css`
  border-radius: 0;
  border: solid 1px ${colors.core03};
  cursor: default;
  && {
    opacity: 1;
  }
`;

const activePageButton = css`
  border-radius: ${spacing(1)};
  &:hover {
    box-shadow: none;
    background-color: ${colorWithOpacity(colors.core03, 0.1)};
    border-color: transparent;
  }
  &:focus-visible {
    box-shadow: none;
    border-color: ${colors.core01};
  }
  &:active {
    box-shadow: none;
    border-color: ${colors.core02};
  }
`;

export const PageNumberButton = styled(Button)`
  span {
    text-align: center;
    margin: auto;
    width: auto;
    height: auto;
  }

  ${styledButton} 
  max-height: ${spacing(6)};  
  min-width: ${spacing(6)};
  min-height: ${spacing(6)};
  padding: ${spacing(1.25)} ${spacing(1.5)};
  margin: 0 ${spacing(1)};
  border: 2px solid transparent;
  
  ${({ disabled }) => (disabled ? disabledPageButton : activePageButton)}
  ${fonts.headingXSmall};

  ${InnerStyle} {
    justify-content: center;
  }
`;
